import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { CardActionArea, Card, CardContent } from '@material-ui/core'
import { Link } from 'gatsby'

const useStyles = makeStyles(theme => ({
  card: {
    ...theme.typography.body2,
    margin: theme.spacing(0, 0, 1, 0),
  },
}))

interface Props {
  title: string
  posts: {
    title: string
    date: string
    slug: string
    excerpt: string
  }[]
}

const MainPosts: FC<Props> = props => {
  const classes = useStyles()
  const { posts, title } = props

  return (
    <Grid item xs={12} md={8}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Divider />
      {posts.map(post => (
        <CardActionArea
          key={post.slug}
          component={Link}
          to={`/blog/${post.slug}`}
        >
          <Card className={classes.card}>
            <CardContent>
              <Typography component="h2" variant="h6">
                {post.title}
              </Typography>
              <Typography variant="subtitle2" color="textSecondary">
                {post.date}
              </Typography>
              <Typography variant="subtitle1" paragraph>
                {post.excerpt}
              </Typography>
              <Typography variant="subtitle2" color="primary">
                Continue reading...
              </Typography>
            </CardContent>
          </Card>
        </CardActionArea>
      ))}
    </Grid>
  )
}

export default MainPosts
